import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisLocationsQueryVariables = Types.Exact<{
  input: Types.HrisLocationsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisLocationsQuery = { __typename?: 'Query', HrisLocations: { __typename?: 'HrisLocations', totalCount: number, objects: Array<{ __typename?: 'HrisLocation', id: number, name: string, createdAt: string, manuallyLinked: boolean, activeHrisEmployeeCount: number, group?: { __typename?: 'Location', id: number, name: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null }> } };

export type DeleteHrisLocationsMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type DeleteHrisLocationsMutation = { __typename?: 'Mutation', deleteHrisLocations: { __typename?: 'GenericMutationResult', success: boolean } };

export type HrisLocationFragment = { __typename?: 'HrisLocation', id: number, name: string, createdAt: string, manuallyLinked: boolean, activeHrisEmployeeCount: number, group?: { __typename?: 'Location', id: number, name: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null };

export const HrisLocationFragmentDoc = gql`
    fragment HrisLocation on HrisLocation {
  id
  name
  createdAt
  group {
    id
    name
  }
  manuallyLinked
  activeHrisEmployeeCount
  hrisIntegration {
    id
    hrisProvider
  }
}
    `;
export const HrisLocationsDocument = gql`
    query HrisLocations($input: HrisLocationsInput!, $pagination: PaginationInput) {
  HrisLocations(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...HrisLocation
    }
  }
}
    ${HrisLocationFragmentDoc}`;

/**
 * __useHrisLocationsQuery__
 *
 * To run a query within a React component, call `useHrisLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisLocationsQuery(baseOptions: Apollo.QueryHookOptions<HrisLocationsQuery, HrisLocationsQueryVariables> & ({ variables: HrisLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisLocationsQuery, HrisLocationsQueryVariables>(HrisLocationsDocument, options);
      }
export function useHrisLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisLocationsQuery, HrisLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisLocationsQuery, HrisLocationsQueryVariables>(HrisLocationsDocument, options);
        }
export type HrisLocationsQueryHookResult = ReturnType<typeof useHrisLocationsQuery>;
export type HrisLocationsLazyQueryHookResult = ReturnType<typeof useHrisLocationsLazyQuery>;
export type HrisLocationsQueryResult = Apollo.QueryResult<HrisLocationsQuery, HrisLocationsQueryVariables>;
export const DeleteHrisLocationsDocument = gql`
    mutation DeleteHrisLocations($ids: [Int!]!) {
  deleteHrisLocations(ids: $ids) {
    success
  }
}
    `;
export type DeleteHrisLocationsMutationFn = Apollo.MutationFunction<DeleteHrisLocationsMutation, DeleteHrisLocationsMutationVariables>;

/**
 * __useDeleteHrisLocationsMutation__
 *
 * To run a mutation, you first call `useDeleteHrisLocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHrisLocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHrisLocationsMutation, { data, loading, error }] = useDeleteHrisLocationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteHrisLocationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHrisLocationsMutation, DeleteHrisLocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHrisLocationsMutation, DeleteHrisLocationsMutationVariables>(DeleteHrisLocationsDocument, options);
      }
export type DeleteHrisLocationsMutationHookResult = ReturnType<typeof useDeleteHrisLocationsMutation>;
export type DeleteHrisLocationsMutationResult = Apollo.MutationResult<DeleteHrisLocationsMutation>;
export type DeleteHrisLocationsMutationOptions = Apollo.BaseMutationOptions<DeleteHrisLocationsMutation, DeleteHrisLocationsMutationVariables>;